export default {"src":"/_next/static/media/es.340a7356.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};